import React from 'react'
import { Flex, Box, Text } from 'rebass'
import styled from 'styled-components'
import Container from '../../elements/Container'
import { colors, fonts, fontSizes, fontWeights } from '../../theme'
import { Divider } from 'rebass/dist/Divider'
import Fade from 'react-reveal/Fade'

const TeamContainer = styled(Flex)`
  background-color: ${colors.white};
  border: 2px solid ${colors.primary};
  border-radius: 10px;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  height: 100%;
`
const Namebox = styled(Box)`
  width: 100%;
  font-weight: ${fontWeights.bold};
  background-color: ${colors.primary};
  color: white;
  padding: 15px;
  &:hover {
    background-color: ${colors.secondary};
    color: ${colors.primary};
  }
`
const TextLink = styled.a`
  text-decoration: none;
  color: ${colors.secondary};
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes[0] + 'px'};
  text-align: center;

  ${Namebox}:hover & {
    color: ${colors.primary};
  }
`
const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  margin-bottom: 0;
  margin-top: 3px;
  border-radius: 15px;
`
const ServiceTitle = styled(Text)`
  font-family: ${fonts.primary};
  font-weight: 700;
  line-height: 1.1;
  font-size: 2.1rem;
`
const TextDetails = styled.ul`
  list-style: none;
  margin: 0;
  text-align: center;
  padding: 10px;
  color: ${colors.white};
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[2] + 'px'};
`
const TeamDetails = styled.ul`
  list-style: none;
  text-align: center;
  padding: 10px;
  margin: 0;
  color: ${colors.greyDark};
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[1] + 'px'};
  font-weight: ${fontWeights.regular};
`

const Partners = () => (
  <Container id="team">
    <Flex w={1} flexWrap="wrap">
      <Box className="flip-box" p={2} w={[1, 1/2, 1 / 2, 1 / 4]}>
        <TeamContainer>
          <ServiceTitle color={colors.primary}>Our team</ServiceTitle>
          <TextSeparator />
          <Fade bottom duration={1000}>
            <TeamDetails>
              The Firm comprises of partners and a multi-disciplinary team of of
              chartered accountants , company secretaries, Advocates, Retired
              Ex- bankers, MBA and other professionals, in their chosen field of
              expertise, assisted by motivated and well-qualified support staff.
              We are passionate about what we do and are highly motivated to
              achieve successful results, desired by our clients.
              <br/>
              <br/>
            </TeamDetails>
          </Fade>
        </TeamContainer>
      </Box>

      <Box
        className="flip-box"
        p={2}
        w={[1, 1/2, 1 / 2, 1 / 4]}
      >
        <Box className="flip-box-inner">
          <Flex className="flip-box-front">
            <img
              src="/img/member1.jpg"
              style={{
                width: '100%',
                overflow: 'hidden',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
            <Namebox>
              CA Shubham Jain
              <div>
                <TextLink>Managing Partner</TextLink>
              </div>
            </Namebox>
          </Flex>
          <Box className="flip-box-back">
            <TextDetails>
              B.Com; A.C.A. (Associate Member of the Institute of Chartered
              Accountants of India) Mr. Jain specialises in Income tax matters –
              Compliance, advisory & litigation . He regularly advises clients
              on their complex issues. Mr. Jain is also well versed with GST law
              and helped the various clients operating under different
              industries in GST implementation. He is a regular speaker on
              various tax matters involving GST & Income tax. Also, his written
              articles have been published by Taxmann on their website and
              journals.
            </TextDetails>
          </Box>
        </Box>
      </Box>

      <Box
        className="flip-box"
        p={2}
        w={[1, 1/2, 1 / 2, 1 / 4]}
      >
        <Box className="flip-box-inner">
          <Flex className="flip-box-front">
            <img
              src="/img/member2.jpg"
              style={{
                width: '100%',
                overflow: 'hidden',
                objectFit: 'cover',
                objectPosition: 'top',
              }}
            />
            <Namebox>
              {' '}
              CA Natasha Jain
              <div>
                <TextLink> Partner</TextLink>
              </div>
            </Namebox>
          </Flex>
          <Box className="flip-box-back">
            <TextDetails>
              B.Com; F.C.A. (Fellow Member of the Institute of Chartered
              Accountants of India); DISA (ICAI) Ms.Natasha has extensive
              experience of over six years in statutory audits, internal audits
              & bank audits. She also has experience in handling search &
              seizure cases and has represented numerous clients before Income
              tax authorities (Till ITAT level) In addition to his vast
              practice, Ms. Natasha is a frequent speaker at various conferences
              and knowledge events.
            </TextDetails>
          </Box>
        </Box>
      </Box>

      <Box className="flip-box" p={2} w={[1, 1/2, 1 / 2, 1 / 4]}>
        <Box className="flip-box-inner">
          <Flex className="flip-box-front">
            <img
              src="/img/member3.jpg"
              style={{
                width: '100%',
                overflow: 'hidden',
                objectFit: 'cover',
                objectPosition: 'top',
              }}
            />
            <Namebox>
              Praveen Kumar Jain
              <div>
                <TextLink>Senior Legal Advisor</TextLink>
              </div>
            </Namebox>
          </Flex>
          <Box className="flip-box-back">
            <TextDetails>
              Shri Jain is a senior legal advisor of the firm with two decades
              of extensive experience in handling numerous clients and advising
              them in their legal and litigative matters. Shri Jain has vast
              experience of indirect tax – VAT & GST. He has represented clients
              in their litigation matters till appellate authority. His
              knowledge and experience has always helped the firm in giving
              advisory to clients to the extent of their needs.
            </TextDetails>
          </Box>
        </Box>
      </Box>
    </Flex>
  </Container>
)

export default Partners



// WEBPACK FOOTER //
// ./src/components/home/Partners.js